import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCertifications(organization_id) {
    return RequesterV1.get(
      `organization/certifications/query_formats/list_certifications/${organization_id}`
    );
  }
};
